const permissions = Object.freeze({
  HOME_ACCESS: 'home_access',
  SLA_ACCESS: 'sla_access',
  SCREENING_ACCESS: 'screening_access',
  COMPLAINTS_ACCESS: 'complaints_access',
  COMPLAINTS_LIST: 'complaints_list',
  USERS_ACCESS: 'users_access',
  ORGANIZATIONS_ACCESS: 'organizations_access'
})

export default permissions
